import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { SummaryCard } from '../../../interfaces/restaurant-shared.interface';

@Component({
  selector: 'app-restaurant-summary-cards',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule
  ],
  templateUrl: './restaurant-summary-cards.component.html',
  styleUrls: ['./restaurant-summary-cards.component.css']
})
export class RestaurantSummaryCardsComponent {
  @Input() cards: SummaryCard[] = [];
  @Input() layout: 'grid' | 'horizontal' = 'horizontal';
}